var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "manageEmailCalendars",
    attrs: {
      id: "manage-email-calendars-modal",
      "modal-dialog-scrollable": false,
      "modal-dialog-size": "lg",
      "tab-index": null,
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("settings.accountTab.manageCalendars")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loadingCalendars
              ? _c("manage-email-calendars-modal-loader")
              : _vm.noCalendars
              ? _c(
                  "no-results",
                  {
                    attrs: {
                      "img-src": require("@Shared/assets/img/email.png"),
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("email.messages.noCalendar")) +
                        "\n    "
                    ),
                  ]
                )
              : _c(
                  "div",
                  [
                    _c("p", { staticClass: "justified mb-3" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("email.messages.manageEmailCalendars")
                          ) +
                          "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      {
                        staticClass:
                          "align-items-center justify-content-start mb-2",
                        attrs: { "no-gutters": "" },
                      },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass:
                              "text-sm-center text-muted text-uppercase",
                            attrs: { sm: "1" },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.words.sync")) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass: "text-sm-left text-muted",
                            attrs: { sm: "3" },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("email.calendarName")) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "text-sm-left text-muted" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("email.calendarDescription")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.syncedCalendars, function (calendar) {
                      return _c(
                        "b-row",
                        {
                          key: calendar.calendarId,
                          staticClass:
                            "align-items-center justify-content-start mb-2 text-primary",
                          attrs: { "no-gutters": "" },
                        },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "text-sm-center align-middle",
                              attrs: { sm: "1" },
                            },
                            [
                              _c("checkbox-section", {
                                attrs: {
                                  name: "single",
                                  "multi-line": false,
                                  "hidden-label": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeSyncedCalendar(
                                      _vm.selectedAccountId +
                                        "-" +
                                        calendar.calendarId
                                    )
                                  },
                                },
                                model: {
                                  value: calendar.synced,
                                  callback: function ($$v) {
                                    _vm.$set(calendar, "synced", $$v)
                                  },
                                  expression: "calendar.synced",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "text-sm-left align-middle",
                              class: { cursive: !calendar.name },
                              attrs: { sm: "3" },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    calendar.name ||
                                      _vm.$t("email.messages.noCalendarName")
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "text-sm-left align-middle text-light-gray",
                              class: { cursive: !calendar.description },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    calendar.description ||
                                      _vm.$t(
                                        "email.messages.noCalendarDescription"
                                      )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            !_vm.noCalendars
              ? _c("simple-button", {
                  attrs: {
                    text: _vm.$t("global.words.save"),
                    loading: _vm.loading,
                    "loading-succeeded": _vm.loadingSucceeded,
                  },
                  on: { click: _vm.handleSave },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }